module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fixed-part"
  }, [_c('x-header', {
    staticClass: "fixed-header",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n      "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-part"
  }, [_c(_vm.who, {
    ref: "childLaunch",
    tag: "component",
    attrs: {
      "saveStatus": _vm.saveStatus
    },
    on: {
      "sendTitleToParent": _vm.getTitleFromChild,
      "sendStatusToParent": _vm.getStatusFromChild
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "submit-dialog",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  }, [_c('img', {
    staticClass: "img-user",
    staticStyle: {
      "padding": "8px 10px 0px 0px"
    },
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/close.png"),
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticStyle: {
      "padding": "0px 15px"
    }
  }, [_c('span', {
    staticClass: "dialog-title"
  }, [_vm._v("选择节点")]), _vm._v(" "), _c('checker', {
    staticClass: "dialog-part dialog-check-list",
    attrs: {
      "selected-item-class": "selected-item"
    },
    on: {
      "on-change": _vm.singleCheck
    },
    model: {
      value: (_vm.checkNodeArr),
      callback: function($$v) {
        _vm.checkNodeArr = $$v
      },
      expression: "checkNodeArr"
    }
  }, _vm._l((_vm.nextFlowNodeArr), function(item) {
    return _c('checker-item', {
      key: item.id,
      attrs: {
        "value": item.stepId + ',' + item.id + ',' + item.openOperatorManualChoose + ',' + item.todoResolveMode
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1), _vm._v(" "), (_vm.nextFlowStaffArr.length > 0) ? _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('span', {
    staticClass: "dialog-title"
  }, [_vm._v("选择人员")]), _vm._v(" "), _c('checker', {
    staticClass: "dialog-part dialog-check-list",
    attrs: {
      "max": 10,
      "type": "checkbox",
      "selected-item-class": "selected-item"
    },
    on: {
      "on-change": _vm.multipleCheck
    },
    model: {
      value: (_vm.checkPersonArr),
      callback: function($$v) {
        _vm.checkPersonArr = $$v
      },
      expression: "checkPersonArr"
    }
  }, _vm._l((_vm.nextFlowStaffArr), function(item) {
    return _c('checker-item', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.checkTreeShow) ? _c('div', [_c('group', {
    attrs: {
      "id": "searchBar"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "搜索",
      "placeholder": "在此输入姓名"
    },
    on: {
      "on-click-clear-icon": _vm.clearSearchResult
    },
    model: {
      value: (_vm.checkTreeSearchVal),
      callback: function($$v) {
        _vm.checkTreeSearchVal = $$v
      },
      expression: "checkTreeSearchVal"
    }
  }, [_c('x-button', {
    attrs: {
      "slot": "right",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.treeSearch($event)
      }
    },
    slot: "right"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "searchResult"
    }
  }, [_c('ul', _vm._l((_vm.checkTreeSearchResult), function(item) {
    return _c('li', [_c('span', [_c('x-button', {
      nativeOn: {
        "click": function($event) {
          _vm.addToTree(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)])
  }))]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "id": "checkType",
      "data": _vm.treeData,
      "props": _vm.treeProps,
      "node-key": "id",
      "show-checkbox": ""
    },
    on: {
      "check-change": _vm.getCheckedNodes
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "confirmSub"
    }
  }, [_c('x-button', {
    attrs: {
      "disabled": !_vm.confirmBtn,
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmAudit($event)
      }
    }
  }, [_vm._v("确认提交")])], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('x-input', {
    staticClass: "weui-vcode",
    attrs: {
      "placeholder": _vm.placeholderStr,
      "disabled": _vm.footerBtnStatus == 0
    },
    model: {
      value: (_vm.opinion),
      callback: function($$v) {
        _vm.opinion = $$v
      },
      expression: "opinion"
    }
  }, [(_vm.footerBtnStatus == 0) ? _c('x-button', {
    staticClass: "btn",
    attrs: {
      "slot": "right",
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.parentStartToChild($event)
      }
    },
    slot: "right"
  }, [_vm._v("保存")]) : _c('x-button', {
    staticClass: "btn",
    attrs: {
      "slot": "right",
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.parentSubmitToChild($event)
      }
    },
    slot: "right"
  }, [_vm._v("提交")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5abfa0d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/launchPages.vue
// module id = gSTx
// module chunks = 0